var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTightSpreads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13878_11632)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.3477,
    y: 6.08691,
    width: 2.43478,
    height: 43.8261,
    rx: 1.21739,
    fill: "url(#paint0_linear_13878_11632)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.2168,
    y: 9.73901,
    width: 2.43478,
    height: 36.5217,
    rx: 1.21739,
    fill: "url(#paint1_linear_13878_11632)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.08789,
    y: 14,
    width: 10.9565,
    height: 28,
    rx: 4,
    fill: "url(#paint2_linear_13878_11632)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_13878_11632)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.3919,
    y: 4.2608,
    width: 1.21739,
    height: 6.08696,
    rx: 0.608696,
    fill: "#EDF0F5",
    fillOpacity: 0.85,
    stroke: "white",
    strokeWidth: 1.21739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.3919,
    y: 45.6522,
    width: 1.21739,
    height: 6.08696,
    rx: 0.608696,
    fill: "#EDF0F5",
    fillOpacity: 0.85,
    stroke: "white",
    strokeWidth: 1.21739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.6167,
    y: 10.8343,
    width: 8.76605,
    height: 34.3313,
    rx: 2.90476,
    fill: "#EDF0F5",
    fillOpacity: 0.85,
    stroke: "white",
    strokeWidth: 2.19048
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38.957,
    y: 14,
    width: 10.9565,
    height: 28,
    rx: 4,
    fill: "url(#paint3_linear_13878_11632)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_13878_11632",
    x: 11.5691,
    y: -7.30028,
    width: 32.8618,
    height: 70.6006,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.47619
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_13878_11632"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_13878_11632",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13878_11632",
    x1: 10.2716,
    y1: 50.7246,
    x2: 18.956,
    y2: 50.3347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13447,
    stopColor: "#38B2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677447,
    stopColor: "#F7E74E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13878_11632",
    x1: 43.1407,
    y1: 46.9371,
    x2: 51.8175,
    y2: 46.4697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13447,
    stopColor: "#38B2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677447,
    stopColor: "#F7E74E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13878_11632",
    x1: 5.7455,
    y1: 42.5185,
    x2: 41.3448,
    y2: 31.2619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13447,
    stopColor: "#38B2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677447,
    stopColor: "#F7E74E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13878_11632",
    x1: 38.6146,
    y1: 42.5185,
    x2: 74.2139,
    y2: 31.2619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13447,
    stopColor: "#38B2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677447,
    stopColor: "#F7E74E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13878_11632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTightSpreads);
export default __webpack_public_path__ + "static/media/tight-spreads.2a480198cf038f0d139c607f40cf23e2.svg";
export { ForwardRef as ReactComponent };